'use client';

import { BRAZE_ANONYMOUS_ID_STORAGE_KEY } from './constants';

export function getOrCreateBrazeAnonymousId(): string {
  const existingId = localStorage.getItem(BRAZE_ANONYMOUS_ID_STORAGE_KEY);
  if (existingId) return existingId;

  const anonymousId = crypto.randomUUID();
  localStorage.setItem(BRAZE_ANONYMOUS_ID_STORAGE_KEY, anonymousId);
  return anonymousId;
}

export function getBrazeAnonymousId(): string | null {
  return localStorage.getItem(BRAZE_ANONYMOUS_ID_STORAGE_KEY);
}

export function clearBrazeAnonymousId(): void {
  localStorage.removeItem(BRAZE_ANONYMOUS_ID_STORAGE_KEY);
}

export function resetBrazeAnonymousState(): void {
  clearBrazeAnonymousId();
}
